/**
 * 처음 화면(요금제가 활성화된 사무소만). 업무 기능은 다음 순서(내 사무소, 거래처, 현장, 인력...)에서 만든다.
 * - 가입 직후 한 번 초기 설정(내 사무소, 자료 옮기기, 상담 연결)을 보여 주고, 건너뛸 수 있다(2026-11-02 대표님).
 * - 내 사무소 정보가 비어 있으면 알림 줄에 "내 사무소 정보를 채워 주세요."를 남긴다.
 */
import { useEffect, useState } from 'react';
import { api, type Who } from '../api.ts';
import { Button, Link, Message, Page } from '../ui.tsx';

export function Home(props: { who: Who; go: (p: string) => void; note: string | null }) {
  // 도구 시험 화면은 서버에 켜져 있을 때만(시험용 서버) 고리를 보인다
  const [toolsOn, setToolsOn] = useState(false);
  useEffect(() => {
    void api('GET', '/api/tools/on').then((r) => setToolsOn(r.ok));
  }, []);
  const [setupSeen, setSetupSeen] = useState(() => {
    try {
      return localStorage.getItem(`ilsoni_setup_seen_${props.who.user_id}`) === '1';
    } catch {
      return true;
    }
  });

  function skip() {
    try {
      localStorage.setItem(`ilsoni_setup_seen_${props.who.user_id}`, '1');
    } catch {
      /* 기억이 막힌 브라우저면 다음에 또 보인다 */
    }
    setSetupSeen(true);
  }

  if (!setupSeen && props.who.role === '소장님') {
    return (
      <Page title="초기 설정">
        <ul>
          <li>내 사무소</li>
          <li>자료 옮기기</li>
          <li>상담 연결</li>
        </ul>
        <p>(시험용 서버: 세 가지는 다음 순서에서 만들어요.)</p>
        <Button primary onClick={skip}>건너뛰기</Button>
      </Page>
    );
  }

  return (
    <Page title={props.who.office_name ?? '일손이'}>
      {!props.who.office_filled && <Message text="내 사무소 정보를 채워 주세요." kind="info" />}
      {props.who.service_status === '결제 실패' && <Message text="결제가 되지 않았어요. 카드를 확인해 주세요." />}
      <Message text={props.note} kind="info" />
      <p>{props.who.display_name} ({props.who.role}), {props.who.plan} {props.who.service_status}</p>
      <p>
        <Link to="/account" go={props.go}>내 계정</Link>
        <Link to="/plan" go={props.go}>요금제</Link>
        {toolsOn && <Link to="/tools" go={props.go}>도구 시험</Link>}
      </p>
    </Page>
  );
}
